import React from 'react';
import { withRouter, Link } from 'react-router-dom';

// Components
import TopNav from 'components/layout/TopNav';

// Images
import footerLogoImage from 'images/logo-footer.png';

//-------------------------------------------------------------------------------------------------------------------

class Layout extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {
            hideMenu,
            history
        } = this.props;

        return (<>
            <TopNav hideMenu={hideMenu} history={history} />
            {this.props.children}
            {/* {this.renderFooter()} */}
        </>);
    }

    renderFooter() {
        return (
            <footer>
                <Link to="/">
                    <img src={footerLogoImage} />
                </Link>
            </footer>
        );
    }
}

export default withRouter(Layout);